module.exports = __webpack_public_path__ + "static/media/slide1.3d7800b5.gif";